<template>
  <div>
    <div
      v-if="loading"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {mapHelper} from '../../mixins/MapMixin'

export default {
    name: "MaterialStationMap",
    mixins: [restApi, mapHelper],
    props: {
        map: {
            type: Object
        },
        disabled: {
            type: Boolean,
            default: false
        },
        selectedContractId: {
            type: Number,
            default: null
        },
        selectedContractIds: {
            type: Array,
            default() {
                return []
            }
        },
    },
    data() {
        return {
            stations: [],
            loading: false
        }
    },
    watch: {
        map() {
          this.$nextTick(function () {
            this.showMarkers()
          })
        },
        stations() {
            this.refreshMarkers()
        },
        selectedContractIds() {
            this.updateStations()
        },
        disabled() {
            if (!this.disabled) {
                this.updateStations()
            } else {
                this.hideMarkers()
            }
        }
    },
    mounted() {
        if (!this.disabled) {
            this.updateStations()
        }
    },
    beforeUnmount() {
        this.hideMarkers()
    },
    methods: {
        updateStations: function () {
            this.loading = true
            let params = {}
            if(this.selectedContractIds && this.selectedContractIds.length > 0) {
                params.contract_ids = this.selectedContractIds
            } else if(this.selectedContractId) {
                params.contract = this.selectedContractId
            }
            this.restFetchParams(this.materialStationUrl, params, this.success, this.fail)
        },
        success: function (data) {
            this.stations = data.data
            this.loading = false
        },
        fail: function () {
            this.loading = false
        },
        refreshMarkers: function () {
            this.hideMarkers()
            this.showMarkers()
        },
        hideMarkers: function () {
            if (this.map != null) {
                this.map.removeMapMarkerByType(this.MATERIAL_STATION)
            }
        },
        showMarkers: function () {
            if (!this.disabled && this.map != null) {
                for (let index in this.stations) {
                    let station = this.stations[index]
                    this.map.showMapMarker(
                        station.id,
                        this.MATERIAL_STATION,
                        station.location.y,
                        station.location.x,
                        this.map.getMarkerStore().getStationMarkerIcon()
                    )
                }
            }
        },
        getStation: function (id) {
            return this.stations.find(station => station.id === id)
        }
    }
}
</script>
